import { render, staticRenderFns } from "./PivotEditorDimensionTab.vue?vue&type=template&id=5cc6066a&scoped=true"
import script from "./PivotEditorDimensionTab.vue?vue&type=script&lang=js"
export * from "./PivotEditorDimensionTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc6066a",
  null
  
)

export default component.exports